'use client';
import styled, { css } from 'styled-components';

export const StyledVideoModal = styled.div`
  ${props =>
    props.videoOrientation === 'portrait'
      ? css`
          height: 80vh;
          width: auto;
          max-width: 95vw;
          mux-player {
            height: 80vh;
          }
        `
      : css`
          height: auto;
          width: 95vw;
          mux-player {
            width: 95vw;
            height: auto;
            display: block;
          }
        `}

  @media ${props => props.theme.laptop} {
    height: 95vh;
    width: auto;
    max-width: 95vw;
    mux-player {
      height: 95vh;
    }
  }
`;
